// import dice from './dice'
import remark from './remark'
// import status from './status'
import textNote from './textNote'
import messageOpen from './messageOpen'
import setBg from './setBg'
import introduction from './introduction'
import messageClose from './messageClose'
import blackOut from './blackOut'
import fadeIn from './fadeIn'
import fadeOut from './fadeOut'
import clear from './clear'
export default {
  components:{
    // dice,
    remark,
    // status,
    textNote,
    messageOpen,
    setBg,
    introduction,
    messageClose,
    blackOut,
    fadeIn,
    fadeOut,
    clear
  },
}
